import { isUuid } from '@utils/isUUID';

const UUID_LENGTH = 36;
const FILENAME_DIVIDER_LENGTH = 1;

export function parseFileName(path: string, trimUUID: boolean = true): string {
    // eslint-disable-next-line sonarjs/no-dead-store
    let result = path;

    const pathSegments = path.split('/');

    const fileName = pathSegments[pathSegments.length - 1];

    const startsWithUUID = isUuid(fileName.slice(0, UUID_LENGTH));

    if (startsWithUUID && trimUUID) {
        const fileNameWithoutUUID = fileName.slice(UUID_LENGTH + FILENAME_DIVIDER_LENGTH);

        if (fileNameWithoutUUID.includes('.')) {
            result = fileNameWithoutUUID;
        } else {
            result = fileName;
        }
    } else {
        result = fileName;
    }

    return result;
}

export function parseFilePath(path: string): string {
    return encodeURIComponent(path).replaceAll('/', '\\');
}

export function parseFileNameFromBase64(base64String: string): string | null {
    const match = /;name=([^;]+);base64,/.exec(base64String);
    return match ? decodeURIComponent(match[1]) : null;
}
